import Grid2 from '@mui/material/Unstable_Grid2';
import { type FilterItem } from 'src/shared/components/Filters/types';
import { initialValues, useBulkActions, useBulkActionsOptions, type FlexflowContractsListFilter } from './hooks';
import { Form } from 'react-final-form';
import { noop } from 'lodash';
import { FormContent } from './FormContent';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { type ResponseWithPaginationMeta } from 'src/shared/api/types';
import { type FlexflowEmployeeDataToDisplay } from '../types';
import { OnChange } from 'react-final-form-listeners';
import { any } from 'src/shared/utils/array';
import Select from 'src/shared/components/Form/Select';
import { type Employee } from 'src/shared/types/employee';
import useMediaQuery from 'src/shared/hooks/useMediaQuery';

type FlexflowContractsListActionsProps = {
  filterValues: FlexflowContractsListFilter;
  filterScheme: FilterItem[];
  setFilterValues: (values: FlexflowContractsListFilter) => void;
  handleChangePage: (event: unknown, newPage: number) => void;
  data: ResponseWithPaginationMeta<FlexflowEmployeeDataToDisplay | Employee>;
  resetFilters?: () => void;
};

export const FlexflowContractsListActions = ({
  setFilterValues,
  filterScheme,
  handleChangePage,
  data,
  resetFilters
}: FlexflowContractsListActionsProps) => {
  const isDownLg = useMediaQuery('lg');
  const { t } = useTranslation(['flexflow', 'actions']);
  const bulkActionsOptions = useBulkActionsOptions();
  const { handleBulkActions, selectedContracts } = useBulkActions(data);

  return (
    <Box display="flex" flexDirection={isDownLg ? 'column' : 'row'} sx={{ width: '100%' }}>
      <Box display="flex" sx={{ flexWrap: 'nowrap', alignItems: 'center', width: isDownLg ? '100%' : 'auto' }}>
        <Grid2 width={isDownLg ? 340 : 'auto'} mb={isDownLg ? 2 : 0}>
          <Select
            sx={{ width: isDownLg ? '100%' : 280, background: 'white' }}
            data={bulkActionsOptions}
            withoutLock
            name="bulkActions"
            label={t('actions', { ns: 'flexflow' })}
            disabled={!any(selectedContracts)}
          />
        </Grid2>
        <Box marginLeft={2}>
          <Typography sx={{ whiteSpace: 'nowrap' }}>
            {t('selected', { ns: 'flexflow' })}: <strong>{selectedContracts?.length}</strong>
          </Typography>
        </Box>
      </Box>
      <OnChange name="bulkActions">{handleBulkActions}</OnChange>

      <Box display="flex" flexGrow={1} justifyContent={isDownLg ? 'flex-start' : 'flex-end'}>
        <Form onSubmit={noop} initialValues={initialValues}>
          {({ form }) => {
            const handleFilterChange = (value: FlexflowContractsListFilter) => {
              if (value) {
                form.change('searchTerm', '');
              }
            };

            return (
              <>
                <FormContent
                  handleChangePage={handleChangePage}
                  setFilterValues={setFilterValues}
                  filterScheme={filterScheme}
                  resetFilters={resetFilters}
                />
                <OnChange name="filters">{handleFilterChange}</OnChange>
              </>
            );
          }}
        </Form>
      </Box>
    </Box>
  );
};
